module.exports = __webpack_public_path__ + "img/bb_g3_t_antenna-03.bb648f31.svg";